import { createContext } from 'react';
import { BillingCycle } from '@/features/common/pricing';
import type { IProductMetadata } from '../../domain';

export const PricingPageContext = createContext<{
  isTrialEnabled: boolean;
  billingCycle: BillingCycle.Monthly | BillingCycle.Yearly;
  productsMetadata: IProductMetadata[];
  maxAnnualDiscount: number;
  onChangeBillingCycle: (
    billingCycle: BillingCycle.Monthly | BillingCycle.Yearly,
  ) => void;
}>({
  isTrialEnabled: false,
  billingCycle: BillingCycle.Yearly,
  productsMetadata: [],
  maxAnnualDiscount: 0,
  onChangeBillingCycle: (_billingCycle: BillingCycle.Monthly | BillingCycle.Yearly) => {
    return;
  },
});
